import React from "react";
import * as S from "./Interlinking.styles";

interface ArrayProps {
  title: string,
  url: string,
  links: Array<ArrayyPropps>,
}

interface ArrayyPropps {
  url: string,
  text: string,
}

interface InterlinkingProps {
  interLinks: Array<ArrayProps>,
}

export default function OneWayInterlinking(props: InterlinkingProps) {
  
    const { interLinks = [] } = props;
    return (
      <S.OneWayInterlinkingTopContainer>
        {
          interLinks.map((interlinkData, index) => (
            <S.OneWayInterlinkingContainer>
                <S.InterlinkingItem>
                    <S.InterlinkingHeader>
                      <S.HeaderInterlinkingAnchor key={index} href={interlinkData?.url}>{interlinkData?.title}</S.HeaderInterlinkingAnchor>
                    </S.InterlinkingHeader>
                    <S.OneWayInterlinkingBody>
                        {interlinkData?.links.map((item, index) => {
                            return (
                                <S.OneWayInterlinkingAnchor key={index} href={item?.url}>{item?.text}</S.OneWayInterlinkingAnchor>
                            )
                        })}
                    </S.OneWayInterlinkingBody>
                </S.InterlinkingItem>
            </S.OneWayInterlinkingContainer>
          ))
        }
      </S.OneWayInterlinkingTopContainer>
    )
}

